<template>
  <div>
    <div v-if="display" class="loading-dots" :class="[loading ? 'loading-in' : 'loading-out']">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
 export default {
   props: {
     loading: Boolean
   },

   data() {
     return {
       display: this.loading,
     }
   },

   watch: {
     loading(val) {
       clearTimeout(this.timer);
       if (val) {
         this.display = true;
       } else {
         this.timer = setTimeout(() => {
           this.display = false;
         }, 300);
       }
     }
   }
 }
</script>

<style lang="scss" scoped>
  @import "../scss/_vars";

  /* .loading-content-enter { */
  /* opacity: 0; */
  /* animation: render-in 300ms forwards; */
  /* animation-delay: 200ms; */
  /* } */
  /*  */
  /* @keyframes render-in { */
  /* 0% { */
  /* opacity: 0; */
  /* } */
  /* 100% { */
  /* opacity: 1; */
  /* } */
  /* } */

  .loading-dots {
    position: relative;

    &.loading-in {
      height: 70px;
    }

    div {
      position: absolute;
      top: 50px;
      left: 50%;
      width: 8*$px;
      height: 8*$px;
      border-radius: 50%;
      background-color: #999;
      opacity: 0.1;
      transition: transform 300ms ease;
    }
  }

  .loading-dots.loading-in {
    div {
      animation: twinkle 1200ms infinite forwards;
    }
    div:nth-child(1) {
      transform: translate3d(-25px, 0, 0);
    }
    div:nth-child(2) {
      animation-delay: 300ms;
    }
    div:nth-child(3) {
      transform: translate3d(25px, 0, 0);
      animation-delay: 600ms;
    }
  }

  .loading-dots.loading-out {
    div {
      transform: translate3d(0, -30px, 0);
    }
  }

  @keyframes twinkle {
    0% {
      opacity: 0.1;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/c-loading.vue